import { Component, Input, LOCALE_ID } from '@angular/core';
import { Location, DatePipe, CommonModule, registerLocaleData } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { RestitucionService } from '../../../services/restitucion.service';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';
import { PrimeModuleModule } from '../../../shared/modules/prime-module/prime-module.module';
import { UiKitModule } from '../../../shared/modules/ui-kit/ui-kit.module';
import { FormatoCostosDesde } from "../../../pipes/formatoCotosDesde.pipe";
import { ReplaceCommaWithDotPipe } from "../../../pipes/replace-comma-with-dot.pipe";
import localeEs from '@angular/common/locales/es';
@Component({
  selector: 'app-detalle-de-movimientos',
  standalone: true,
  imports: [
    CommonModule,
    CommonNgModule,
    UiKitModule,
    PrimeModuleModule,
    FormatoCostosDesde,
    ReplaceCommaWithDotPipe
],
providers: [
  { provide: LOCALE_ID, useValue: 'es' }
],
  templateUrl: './detalle-de-movimientos.component.html',
  styleUrl: './detalle-de-movimientos.component.scss'
})
export class DetalleDeMovimientosComponent {
  detalle:any = [];
  fechaAper: any;
  excedente:any;
  datePipe:any  = new DatePipe("en-US");
  fechaString: any;
  beneficiarioTitular:any;
  @Input() RutUser:any;
  constructor(
    private activatedRoute: ActivatedRoute,
      private _location: Location,
      private restitucionService: RestitucionService
    ) {
      registerLocaleData(localeEs);
    }

  ngOnInit() {
    this.getDetalleExcedentes(this.RutUser);
  }

  getDetalleExcedentes(rut:any): void {
      this.restitucionService.detalleMovimientosRestitucion().subscribe( (detalleMovimientos:any) => {        
        if(detalleMovimientos.code === 0) {
          this.detalle = detalleMovimientos.response;
        }
      });
  }

  backClicked() {
    this._location.back();
  }
}
